import { Button, Container, Grid, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import AboutSingleTeacher from "../../components/client/singleTeacher/AboutSingleTeacher";
import AvailablitySingleTeacher from "../../components/client/singleTeacher/AvailablitySingleTeacher";
import HeaderSingleTeacher from "../../components/client/singleTeacher/HeaderSingleTeacher";
import ResumeSingleTeacher from "../../components/client/singleTeacher/ResumeSingleTeacher";
import StdeuntsTypeSingleTeacher from "../../components/client/singleTeacher/StdeuntsTypeSingleTeacher";
import Navbar from "../../components/Navbar";
import { useSingleTeacher } from "../../hooks/useSingleTeacher";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../components/Loading";
import { useSelector } from "react-redux";
import RatingTeacher from "../../components/client/singleTeacher/RatingTeacher";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
import PayingTeacher from "../../components/client/singleTeacher/PayingTeacher";
import axios from "axios";
import LectureSingleTeacher from "../../components/client/singleTeacher/LectureSingleTeacher";
import { ExamSingleTeacher } from "../../components/client/singleTeacher/ExamSingleTeacher";
import PackageSingleTeacher from "../../components/client/singleTeacher/PackageSingleTeacher";
import DicountSingleTeacher from "../../components/client/singleTeacher/DicountSingleTeacher";
import ChatIcon from '@mui/icons-material/Chat';
import CallIcon from '@mui/icons-material/Call';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
export default function SingleTeacher() {
  const { id, packageId } = useParams();
  const { currency } = useSelector((state) => state.currency);
  const { data, isLoading } = useSingleTeacher(id, currency);
  const { student } = useSelector((state) => state.student);
  const [teacherData,setTeacherData]=useState()
  
  const { t } = useTranslation();
  const navigate = useNavigate();
   useEffect(() => {
       const fachTeacher=async()=>{
         const res=await axios.get(
           `${process.env.REACT_APP_API_KEY}api/v1/teacher/getSingleTeacher/${id}`,
           {
             headers: {
               "Content-Type": "multipart/form-data",
             },
           }
         );
         
         setTeacherData(res.data)
       }
       fachTeacher()
     }, []);
     
  const handleCreateMessage = async () => {
    if (!student) {
      swal({ text: t("login_as_student"), icon: "error", button: t("ok") });
      return;
    }
    const addFrind=(async () => {
      await fetch(`${process.env.REACT_APP_API_KEY}api/v1/chat/add`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user1Id: student?.id, user1Type:"student", user2Id:id, user2Type:"teacher"
        })
      });
    })
    addFrind();
    navigate(`/student/messages`);
  };

  const handleRequestBook = async () => {
    if (!student) {
      swal({ text: t("login_as_student"), icon: "error", button: t("ok") });
      return;
    }
    console.log(data?.data.id);
    
    navigate(`/book/${data?.data.id}`);
  };

  const handleClick = (phoneNumber) => {
    if (!student) {
      swal({ text: t("login_as_student"), icon: "error", button: t("ok") });
      return;
    }
  
    if (!phoneNumber) {
      swal({ text: t("The teacher does not have a phone number."), icon: "error", button: t("ok") });
      return;
    }
  
    // بدء الاتصال
    window.location.href = `tel:${phoneNumber}`;
  };
  
  
  
  function handleRequestPackage() {
    if (!student) {
      swal({ text: t("login_as_student"), icon: "error", button: t("ok") });
      return;
    }
    navigate(`/request-package/${data?.data.id}/${packageId}`);
  }

  return (
    <Navbar>
      {isLoading ? (
        <Loading />
      ) : (
        <Container sx={{ marginBottom: "40px", marginTop: "80px" }}>
          <Grid container spacing={3}>
            <Grid item md={12} lg={8}>
              <HeaderSingleTeacher teacher={teacherData?.data} />
              <AboutSingleTeacher teacher={teacherData?.data} />
              <StdeuntsTypeSingleTeacher teacher={teacherData?.data} />
              <AvailablitySingleTeacher teacher={teacherData?.data} />
              <RatingTeacher rates={teacherData?.data.Rates} teacher={teacherData} />
              <PayingTeacher teacher={teacherData?.data} />
              <ResumeSingleTeacher teacher={teacherData?.data} />
              {teacherData?.data.lectures?.length>0?<LectureSingleTeacher teacher={teacherData?.data.lectures}/>:""}
               {teacherData?.data.packages?.length>0?<PackageSingleTeacher teacher={teacherData?.data.packages}/>:""}
               {teacherData?.data.exams?.length>0?<ExamSingleTeacher  exams={teacherData?.data.exams}  subjects={teacherData?.data.subjects}/>:""}
               {teacherData?.data.discounts?.length>0?<DicountSingleTeacher teacher={teacherData?.data.discounts}/>:""}
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
  <Paper sx={{ padding: "24px 12px", my: 3 }}>
    <Button
      variant="outlined"
      color="primary"
      fullWidth
      sx={{ textTransform: "capitalize", mb: 2 }}
      onClick={handleRequestBook}
    >
      <BookmarkBorderIcon sx={{ mr: 1 }} />
      {t("requestBook")}
    </Button>

    {/* زر الاتصال يظهر فقط على الشاشات الصغيرة */}
    <Button
      variant="outlined"
      color="error"
      fullWidth
      sx={{ 
        textTransform: "capitalize", 
        mb: 2,
        display: { xs: "flex", md: "none" } // يظهر فقط في الشاشات الصغيرة
      }}
      onClick={() => handleClick(teacherData?.data?.phone)}
    >
      <CallIcon sx={{ mr: 1 }} />
      {t("Teacher Phone Call")}
    </Button>

    {packageId && (
      <Button
        variant="contained"
        fullWidth
        sx={{ textTransform: "capitalize", mb: 2 }}
        onClick={handleRequestPackage}
      >
        {t("requestPackage")}
      </Button>
    )}

    <Button
      variant="outlined"
      fullWidth
      sx={{ textTransform: "capitalize" }}
      onClick={handleCreateMessage}
    >
      <ChatIcon sx={{ mr: 1 }} />
      {t("contactTeacher")}
    </Button>
  </Paper>
</Grid>

          </Grid>
        </Container>
      )}
    </Navbar>
  );
}
